import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { PaginatedResponse } from '@/core/api/dtos/common/types'
import { Invoice } from '@/core/api/entities/invoice/invoice'
import { InvoiceMapper } from '@/core/api/mappers/invoice/invoice'
import { accountService } from '@/core/api/services/account/accountService'
import { DEFAULT_PARAMS } from '@/core/hooks/common'

/**
 * Get invoices for the current account with pagination
 */
export const useInvoices = ({
	accountId,
	config,
	options,
}: any = DEFAULT_PARAMS): UseQueryResult<PaginatedResponse<Invoice>, Error> => {
	const QUERY_KEY = ['invoices', accountId, { ...config?.params }]

	return useQuery({
		queryKey: QUERY_KEY,
		queryFn: () =>
			accountService
				.getInvoices(accountId, config)
				.then(({ data: response }) => {
					return {
						data: InvoiceMapper.toEntities(response.data),
						meta: response.meta,
					}
				}),
		...options,
	})
}
